document.addEventListener('DOMContentLoaded', function () {
    // Sélectionner tous les éléments contenant des nombres
    const numberElements = document.querySelectorAll('[id^="number-"]');

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const element = entry.target;
                const targetText = element.getAttribute('data-target');
                const match = targetText.match(/^([+\-\s]*)(\d+)([%]*)$/);
                const prefix = match ? match[1] : '';
                const numericPart = match ? parseFloat(match[2]) : 0;
                const suffix = match ? match[3] : '';
                const duration = 4000;
                const increment = numericPart / (duration / 50);

                let currentValue = 0;

                function animateNumber() {
                    if (currentValue < numericPart) {
                        currentValue += increment;
                        if (currentValue > numericPart) currentValue = numericPart;

                        element.textContent = prefix + Math.round(currentValue) + suffix;

                        requestAnimationFrame(animateNumber);
                    } else {
                        element.textContent = prefix + Math.round(numericPart) + suffix;
                    }
                }

                animateNumber();
                observer.unobserve(element);
            }
        });
    }, {
        threshold: 0.5  // visible à 50%
    });

    numberElements.forEach(element => {
        observer.observe(element);
    });
});
